import { DownloadService } from '@cosmos/util-download/common';

import { WebDownloadService } from './web-download.service';

export const provideWebDownload = () => [
  WebDownloadService,
  { provide: DownloadService, useExisting: WebDownloadService },
];

export { WebDownloadService };
